import React, {FC} from 'react';
import {useIntl} from 'react-intl';
import {ALIGN, Box, COLOR, Icon, Layout, SPACE, Text, TitleIcon, useDevice, View} from '@lookiero/aurora';
import type {IconProperties} from '@lookiero/aurora';
import {Section} from '@views/Referrals';

import {ShareButtons} from '@views/Referrals/_components/ShareButtons/ShareButtons';
import {style} from './HowItWorks.styles';
import {TEXT} from './HowItWorks.definition';
import {ConfigurationApplication} from '@application/Config';
import {TradeName} from '@domain/model/Config/Configuration';

const Row: FC<{icon: IconProperties['name']; text: string}> = ({icon, text}) => {
  const {screen} = useDevice();
  return (
    <View style={style.rowContainer} marginTop={SPACE.SPACE_4}>
      <View style={style.rowIconContainer}>
        <View style={style.rowIconSubContainer}>
          <Icon name={icon} style={style.rowIcon} color={COLOR.ICON} />
        </View>
      </View>
      <View style={style.rowTextContainer}>
        <Text detail={!screen.L} level={screen.L ? 3 : 1} style={style.rowText}>
          {text}
        </Text>
      </View>
    </View>
  );
};

export interface HowItWorksProps {
  referralCredit: number;
  referredCredit: number;
  referralCode?: string;
}

const Title: FC = () => {
  const {formatMessage} = useIntl();
  const {tradename} = ConfigurationApplication.retrieve();
  const text = formatMessage(TEXT.TITLE);
  return tradename === TradeName.LOOKIERO ? (
    <TitleIcon text={text} icon="double_half_circle" />
  ) : (
    <Text action level={3} alignSelf={ALIGN.LEFT}>
      {text}
    </Text>
  );
};

export const HowItWorks: FC<HowItWorksProps> = ({referralCredit, referredCredit, referralCode = ''}) => {
  const {formatMessage} = useIntl();
  const {screen} = useDevice();

  return (
    <View style={style.container} paddingVertical={screen.L ? SPACE.SPACE_16 : SPACE.SPACE_8} testID={'how-it-works'}>
      <Layout>
        <Box size={{L: '1/3', M: '2/3'}} align={ALIGN.CENTER}>
          <Title />
          <Text heading level={screen.L ? 2 : 3} marginTop={SPACE.SPACE_4}>
            {formatMessage(TEXT.SUBTITLE)}
          </Text>
          <View style={style.explanationContainer} marginTop={screen.L ? SPACE.SPACE_8 : SPACE.SPACE_3}>
            <Row icon={'share'} text={formatMessage(TEXT.STEP1)} />
            <Row icon={'referrals'} text={formatMessage(TEXT.STEP2, {referredCredit})} />
            <Row icon={'hanger'} text={formatMessage(TEXT.STEP3)} />
            <Row icon={'gift'} text={formatMessage(TEXT.STEP4, {referralCredit})} />
          </View>
          <View marginTop={screen.L ? SPACE.SPACE_12 : SPACE.SPACE_10}>
            <ShareButtons
              referredCredit={referredCredit}
              section={Section.REFERRAL_VIEW}
              referralCode={referralCode}
              showMoreInfoLink
              testID={'how-it-works'}
            />
          </View>
        </Box>
      </Layout>
    </View>
  );
};
